import { AmbulanzType } from "@/api";

export interface AmbulanzFormValues {
  type: AmbulanzType;
  ambulanzNumber: string;
  clientId: string | null;
  clientName: string | null;
  phone: string;
  email: string;
  note: string;
}

export interface AmbulanzTypeOption {
  id: AmbulanzType;
  label: string;
}

export const AmbulanzMaxLength = {
  ambulanzNumber: 50,
  clientName: 200,
  phone: 50,
  email: 50,
  note: 2000,
};
